export const NotificationConstant = {
  ApplicationReview: {
    Success: 'Application submitted successfully.'
  },
  Asset: {
    AddError: 'Unable to add Asset details.',
    FetchError: 'Unable to get Asset details.',
    Finicity_Error: 'Unable to process your request. please try again.',
    Finicity_Event: 'finicity_message',
    Finicity_GetIFrameUrlError: 'Failed to connect to finicity',
    Finicity_Subscription: 'Finicity',
    Finicity_Success: 'Your Finicity integration is in progress. It will be updated soon.',
    Finicity_UnCompleted: 'Finicity integration not yet completed.',
    RemoveError: 'Unable to delete asset detail',
    RemoveSuccess: 'Asset detail removed successfully.',
    Skip: 'You skipped asset information.',
    Success: 'Asset details saved successfully.',
    UpdateError: 'Failed to update asset detail.',
    ValidationError: 'Please answer all above questions.'
  },
  CurrentIncome: {
    AddError: 'Unable to add Current Income details.',
    FetchError: 'Unable to get Income details.',
    Success: 'Income details saved successfully.',
    UpdateError: 'Unable to update Income details.'
  },
  Declarations: {
    FetchError: 'Unable to get declaration details.',
    Success: 'Declaration details saved successfully.',
    ValidationError1: 'Please answer all the sections in the application.',
    ValidationError2: 'Please answer all above questions.'
  },
  DemoGraphic: {
    FetchError: 'Unable to get demographic details.',
    Success: 'Demographic details saved successfully.',
    UpdateError: 'Unable to save demographic details.',
    ValidationError: 'Please answer all above questions.'
  },
  Disclosure: {
    FetchError: 'Unable to set disclosure agreement.',
    Success: 'Disclosure agreement updated successfully.',
    UpdateError: 'Unable to update the disclosure agreement.'
  },
  EmployeeHistory: {
    FetchError: 'Unable to get Employment details.',
    Success: 'Employment history details saved successfully.',
    UpdateError: 'Unable to save Employment history details.'
  },
  Finicity: {
    Error: 'Unable to process your request. please try again.',
    Success: "Thanks for importing your assets! We'll generate a report with your selections and deliver it your lender."
  },
  Housing: {
    FetchError: 'Unable to get Hosing details.',
    Success: 'Housing details saved successfully.',
    UpdateError: 'Unable to save Housing details.'
  },
  Liability: {
    Delete: 'Liability details deleted successfully.',
    DeleteError: 'Unable to Delete Liability details.',
    FetchError: 'Unable to get Liability details.',
    Success: 'Liability details saved successfully.',
    UpdateError: 'Unable to save Liability details.',
    ValidationError: 'Please answer all above questions.'
  },
  LoanInfo: {
    DownPaymentWarning: 'Down payment and total down payment should be same.',
    Success: 'Loan details saved successfully.',
    UpdateError: 'Unable to save Loan details.'
  },
  LocalStorage: {
    LogOut_Event: 'ecp-logout-event',
    Window_Event_Name: 'storage'
  },
  PersonalInfo: {
    SaveError: 'Unable to save Personal details.'
  },
  PricingCompare: {
    DownloadDocumentError: 'Unable to download document.',
    FetchError: 'Unable to get Pricing list.',
    Success: 'Pricing program updated successfully.',
    UpdateError: 'Unable to update the selected pricing.'
  },
  PricingPage: {
    FetchError: 'Unable to get Pricing list.',
    Success: 'Pricing program updated successfully.',
    UpdateError: 'Unable to update the selected pricing.'
  },
  PricingQuestion: {
    Success: 'Pricing questions saved successfully.'
  },
  PropertyDetail: {
    AddError: 'Unable to add Property details.',
    FetchError: 'Unable to get Property details.',
    Success: 'Property details saved successfully.'
  },
  PropertyTitle: {
    SaveError: 'Unable to save property title details.',
    Success: 'Property Title details saved successfully.',
    FetchError: 'Unable to get property title details.'
  },
  RealEstate: {
    Success: 'Real Estate details saved successfully.',
    AddError: 'Unable to add Realestate details.',
    FetchError: 'Unable to get Realestate details.',
    SaveError: 'Unable to save Realestate details.'
  },
  SignUp: {
    Error: 'Unable to signup.',
    Success: 'Signed up successfully',
    Failed: 'Unable to process the request, Please try again later.'
  },
  EConsent: {
    FetchError: 'Unable to save property title details.',
    Success: 'Property Title details saved successfully.',
    SubmitSuccess: 'Successfully submitted the loan application.',
    SubmitFail: 'Failed to submit the loan application.'
  },
  ESign: {
    FetchError: 'Unable to get loan officer and processor details.',
    UpdateError: 'Unable to update eSign status.',
    GetError: 'Unable to get eSign status.',
    GetIFrameError: 'Unable to Get eSign iFrame Url.',
    Success: ' Your document has been successfully',
    ESign_Subscription: 'ESign',
    ESign_Event: 'ESign_Response',
    MimeType: 'application/pdf'
  },
  Navigation: {
    FetchError: 'Unable to get loan officer and processor details.'
  },
  Dashboard: {
    FetchError: 'Unable to get the loan list details.'
  },
  LoanDecision: {
    FetchError: 'Unable to get the decisions.'
  },
  AppSubmitted: 'AppSubmitted',
  DisableNavigation: 'DisableNavigation',
  DocumentTodo: 'DocumentTodo',
  DisableUserDropDown: 'DisableUserDropDown'
};
